<td fit-closest-table [translate]="message" data-cy="TableIsEmpty">
</td>
